module.exports = __webpack_public_path__ + "static/slide-3-d6a99cf21c40bfd4ae9694a0733a791b.jpg";